import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CMSProvider } from "./contexts/CMSContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <CMSProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </CMSProvider>
    </I18nextProvider>
  );
}

export default App;
